package com.anjuros.website.templates.template5.modules

import com.anjuros.website.templates.template5.util.ResKey


enum class Template5Review(
    val review:ResKey,
    val author:ResKey,
    val job:ResKey,
    val icon:String
) {
    Template5Review1(review = ResKey.TEMPLATE5_REVIEW1,
        author =  ResKey.TEMPLATE5_REVIEW1_NAME,
        job =  ResKey.TEMPLATE5_REVIEW1_TITLE,
        icon = "template5_review1.jpg"),

    Template5Review2(review = ResKey.TEMPLATE5_REVIEW2,
        author =  ResKey.TEMPLATE5_REVIEW2_NAME,
        job =  ResKey.TEMPLATE5_REVIEW2_TITLE,
        icon = "template5_review2.jpg"),

    Template5Review3(review = ResKey.TEMPLATE5_REVIEW3,
        author =  ResKey.TEMPLATE5_REVIEW3_NAME,
        job =  ResKey.TEMPLATE5_REVIEW3_TITLE,
        icon = "template5_review3.jpg"),
}